import React from 'react';
import ReportingMembershipsLapsedPage from '../components/ReportingMembershipsLapsedPage';

const ReportingMembershipsLapsedApp = (props) => (
  <ReportingMembershipsLapsedPage {...props} />
);

export default ReportingMembershipsLapsedApp;
